
import { postNewCancelForm } from '../api.js'

import notifications from '../notifications.js'

function _postNewCancelForm(data, id) {
  let promise = postNewCancelForm(data, id)

  promise
    .then(() => {
      notifications.pushInfo('All validation complete, form submitted.')
    })
    .catch(error => {
      notifications.pushError(`Form submission failed! ${error.response.data}`, error)
    })

  return promise
}

function _canSubmitForm(user) {
  if (user === undefined) {
    return false
  }

  return user.can('cancel_student')
}

function _init() {
  // do nothing
}

_init()

export default {
  postNewCancelForm: _postNewCancelForm,

  canSubmitForm: _canSubmitForm,
}
